import { chunkRecoveryStatus } from '@core/utils/error-handling/chunk-recovery-status'
import { isDevDeploy } from '@core/utils/error-handling/is-dev-deploy'
import { shouldReloadOnChunkError } from '@core/utils/error-handling/should-reload-on-chunk-error'
import type { AnyRouter } from '@tanstack/react-router'

export function activateChunkRecovery(router: AnyRouter) {
  window.addEventListener('vite:preloadError', () => {
    const shouldReload = shouldReloadOnChunkError({
      isDevDeploy,
      pageAlreadyRendered: router.state.resolvedLocation !== undefined,
      navigationInFlight: router.state.isLoading,
      isOnline: navigator.onLine,
      loadedByReload:
        (
          performance.getEntriesByType(
            'navigation'
          ) as PerformanceNavigationTiming[]
        )[0]?.type === 'reload',
    })

    if (shouldReload) {
      chunkRecoveryStatus.isReloading = true
      window.location.reload()
    }
  })
}
